import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardMedia, Typography, Button, makeStyles, Grid } from '@material-ui/core';
import SendIcon from '@mui/icons-material/ArrowForward';
import Parser from 'html-react-parser';
import { useDevice } from 'components/DeviceContext.js';
import axios from 'axios';

const useStyles = makeStyles({
    root: {
        maxWidth: 300,
        margin: '20px',
        backgroundColor: 'var(--laranja)',
        padding: '1em',
        borderRadius: '2em',
        color: 'var(--branco)',
        height: '80%', // Definindo a altura dos cards como 100% para garantir que todos tenham a mesma altura
        display: 'flex',
        flexDirection: 'column' // Ajustando a direção do fluxo para coluna
    },
    media: {
        height: 200,
        borderRadius: 20
    },

    content: {
        maxHeight: 160,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        color: 'var(--branco)',
        fontSize: '1em'
    },
    title: {
        display: '-webkit-box',
        WebkitLineClamp: 3,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontWeight: '600',
        fontSize: '20px'
    },

});

const NewsComponent = () => {
    const { isDesktop, isMobile } = useDevice(); // Adicionei isMobile
    const classes = useStyles();
    const [noticias, setNoticias] = useState([]);
    const [loading, setLoading] = useState(true);
    const removeImages = (htmlContent) => {
        const modifiedContent = htmlContent.replace(/<img.*?>/g, '');
        return modifiedContent;
    };

    const shortenText = (text, maxLength) => {
        if (text.length > maxLength) {
            return text.slice(0, maxLength - 3) + '...';
        } else {
            return text;
        }
    };

    useEffect(() => {
        axios
            .get('https://cnm.org.br/api/noticias?limit=4&categoria=fia&sort=created_at&order=desc')
            .then((response) => {
                const noticiasData = response.data.noticias.data.map((noticia) => {
                    if (!noticia.imagem.startsWith('http') && !noticia.imagem.startsWith('www')) {
                        noticia.imagem = `https://cnm.org.br${noticia.imagem}`;
                    }

                    noticia.conteudo = noticia.conteudo.replace(/[^\x20-\x7E]/g, '');
                    return noticia;
                });
                // console.log('Dados da API:', noticiasData);
                setNoticias(noticiasData);
                setLoading(false);
            })
            .catch((error) => {
                console.error('Erro ao obter notícias:', error);
            });
    }, []);

    return (
        <Grid container justifyContent="center" style={{ padding: isDesktop ? '0 9em' : '', }}>
            <Grid item xs={12} align="center">
                <h1 style={{ fontSize: '3em', color: 'var(--azul)' }}>
                    NOTÍCIAS
                </h1>
            </Grid>
            {noticias.map((article, index) => (
                <Grid item key={index} xs={12} sm={isMobile ? 12 : 6} md={isMobile ? 12 : 4} lg={isMobile ? 12 : 3}>
                    <Card className={classes.root}>
                        <CardMedia
                            className={classes.media}
                            image={article.imagem}
                            title={article.title}
                        />
                        <CardContent>
                            <Typography gutterBottom component="h2" className={classes.title}>
                                {article.titulo}
                            </Typography>
                            <Typography variant="body2" color="textSecondary" component="div" className={classes.content} style={{ overflow: 'hidden', display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 5 }}>
                                {Parser(removeImages(shortenText(article.conteudo, 0)))}
                            </Typography>

                            <Grid container justifyContent="flex-end" style={{ marginBottom: '-40px', marginTop: '5px' }}>
                                <Button
                                    component="a"
                                    href={`/noticia/${article.id}`}
                                    size="large"
                                    endIcon={<SendIcon style={{ color: 'var(--branco)', fontWeight: '600' }} />}
                                    style={{ padding: '2em' }}
                                >
                                    {/* Ver Notícia */}
                                </Button>
                                {/* <Button component={Link} to={`/noticia/${article.id}`} size="large" endIcon={<SendIcon style={{ color: 'var(--branco)', fontWeight: '600' }} />} /> */}
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
            ))}
        </Grid>
    );
};

export default NewsComponent;
